import { useMemo } from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { LocationSelectorModalController } from './location-selector-modal.controller';

// eslint-disable-next-line import/no-named-as-default-member
const LocationSelectorModal = NiceModal.create(LocationSelectorModalController);

export const useLocationSelectorModal = () => {
  const { show } = useModal(LocationSelectorModal);
  return useMemo(() => ({ open: () => show() }), [show]);
};
